const set = require('lodash/set');

module.exports = pairs => pairs
    .reduce((current, [key, value]) => set(current, key, value), {});
